import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Global } from 'src/app/@core/global/global';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';
import { SeoService } from '../../@resources/services/SEO.service';
@Component({
  selector: 'success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.scss'],
})
export class SuccessComponent implements OnInit {
  constructor(
    private global: Global,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private storage: LocalStorageService,
    private router:Router,
    private readonly seoService: SeoService,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.setTitle();
  }
  	setTitle() {
    const lang = this.localStorage.get('lang')
    lang == 'en' ? this.seoService.updateTitle('success') : this.seoService.updateTitle('النجاح');
  	}
  goToOrders(){
    this.router.navigate(['/account/orders'])
  }
}